import {BaseModel} from '@/models/base.model.js'

/**
 * Channel model
 */
export class Channel extends BaseModel {
}
